import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const FeaturedTestimonialHero = ({ testimonials }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (testimonials?.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % testimonials?.length);
      }, 8000);
      return () => clearInterval(interval);
    }
  }, [testimonials]);

  const currentTestimonial = testimonials?.[currentIndex];

  if (!currentTestimonial) return null;

  const renderStars = (rating) => {
    return (
      <div className="flex items-center gap-1">
        {[...Array(5)]?.map((_, index) => (
          <Icon
            key={index}
            name="Star"
            size={20}
            className={index < rating ? 'text-amber-400 fill-amber-400' : 'text-white/30'}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-emerald-600 rounded-lg shadow-lg overflow-hidden">
      <div className="p-8 md:p-12">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Award" size={24} className="text-white" />
          <span className="text-white/90 text-sm font-medium">Featured Success Story</span>
        </div>
        
        <div className="mb-6">
          {renderStars(currentTestimonial?.starRating)}
        </div>

        <blockquote className="text-white text-xl md:text-2xl font-medium mb-6 leading-relaxed">
          "{currentTestimonial?.reviewText}"
        </blockquote>

        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <p className="text-white font-semibold text-lg">{currentTestimonial?.reviewerName}</p>
            <p className="text-white/80 text-sm">{currentTestimonial?.reviewerPosition}</p>
            <p className="text-white/70 text-sm">{currentTestimonial?.companyName}</p>
          </div>

          <div className="flex items-center gap-6">
            <div className="text-center">
              <p className="text-white text-2xl font-bold">K{(currentTestimonial?.costSavingsKina || 0)?.toLocaleString()}</p>
              <p className="text-white/70 text-xs">Cost Savings</p>
            </div>
            <div className="text-center">
              <p className="text-white text-2xl font-bold">{currentTestimonial?.timeEfficiencyGainPercentage || 0}%</p>
              <p className="text-white/70 text-xs">Efficiency Gain</p>
            </div>
            <div className="text-center">
              <p className="text-white text-2xl font-bold">{currentTestimonial?.regulatoryAdherenceScore || 0}%</p>
              <p className="text-white/70 text-xs">Compliance Score</p>
            </div>
          </div>
        </div>

        {/* Navigation Dots */}
        {testimonials?.length > 1 && (
          <div className="flex items-center justify-center gap-2 mt-8">
            {testimonials?.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex ? 'bg-white w-8' : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedTestimonialHero;